import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballOrganizerService } from "../../../../../commons";
import { StatusEnum } from "../../../../../commons/enums/status-enum";

interface IFootballOrganizerDeleteState {
  footballOrganizerDeleteStatus: StatusEnum;
}

const initialState: IFootballOrganizerDeleteState = {
  footballOrganizerDeleteStatus: StatusEnum.Idle,
};

export const footballOrganizerDelete = createAsyncThunk(
  "footballOrganizerDelete",
  async (footballOrganizerId: number, thunkAPI) => {
    try {
      const footballOrganizerDeleteResponse = await manageFootballOrganizerService.delete(footballOrganizerId);
      return footballOrganizerDeleteResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageFootballOrganizerDeleteSlice = createSlice({
  name: "footballOrganizerDelete",
  initialState: initialState,
  reducers: {
    cleanUpFootballOrganizerDelete(state) {
      state.footballOrganizerDeleteStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(footballOrganizerDelete.pending, (state) => {
        state.footballOrganizerDeleteStatus = StatusEnum.Loading;
      })
      .addCase(footballOrganizerDelete.fulfilled, (state) => {
        state.footballOrganizerDeleteStatus = StatusEnum.Succeeded;
      })
      .addCase(footballOrganizerDelete.rejected, (state) => {
        state.footballOrganizerDeleteStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpFootballOrganizerDelete } = manageFootballOrganizerDeleteSlice.actions;
export default manageFootballOrganizerDeleteSlice.reducer;
